export default __webpack_public_path__ + "static/media/640_business02-en-mobile.6a7c8d94.png";